import {charcoal} from '../../sass/v2/_exports.sass';

export const CameraIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 10.6667C13.1093 10.6667 10.6667 13.1093 10.6667 16C10.6667 18.8907 13.1093 21.3333 16 21.3333C18.8907 21.3333 21.3333 18.8907 21.3333 16C21.3333 13.1093 18.8907 10.6667 16 10.6667ZM16 18.6667C14.58 18.6667 13.3333 17.42 13.3333 16C13.3333 14.58 14.58 13.3333 16 13.3333C17.42 13.3333 18.6667 14.58 18.6667 16C18.6667 17.42 17.42 18.6667 16 18.6667Z"
        fill={color}
      />
      <path
        d="M26.6667 6.66667H23.2187L19.6093 3.05733C19.4857 2.93328 19.3388 2.83489 19.177 2.76785C19.0152 2.7008 18.8418 2.66641 18.6667 2.66667H13.3333C13.1582 2.66641 12.9848 2.7008 12.823 2.76785C12.6612 2.83489 12.5143 2.93328 12.3907 3.05733L8.78133 6.66667H5.33333C3.86266 6.66667 2.66666 7.86267 2.66666 9.33333V24C2.66666 25.4707 3.86266 26.6667 5.33333 26.6667H26.6667C28.1373 26.6667 29.3333 25.4707 29.3333 24V9.33333C29.3333 7.86267 28.1373 6.66667 26.6667 6.66667ZM5.33333 24V9.33333H9.33333C9.688 9.33333 10.0267 9.19333 10.276 8.94267L13.8853 5.33333H18.1147L21.724 8.94267C21.8476 9.06672 21.9945 9.16511 22.1563 9.23216C22.3181 9.2992 22.4915 9.33359 22.6667 9.33333H26.6667L26.6693 24H5.33333Z"
        fill={color}
      />
    </svg>
  );
};
